import { ListHelper } from './../helpers/ListHelper';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Config } from '../classes/Config';
import { Global } from '../classes/Global';
import { StringHelper } from '../helpers/StringHelper';
import { BaseComponent } from '../classes/BaseComponent';
import { LoginHelper } from '../helpers/LoginHelper';
import { StorageHelper } from '../helpers/StorageHelper';

@Component({
  selector: 'app-child-movies',
  templateUrl: './child-movies.component.html',
  styleUrls: ['./child-movies.component.scss']
})
export class ChildMoviesComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() movies;
  @Input() currency; //because the childMovies do not have the currency

  @Output() onWishlistAction = new EventEmitter<{ movie: any, action: 'add' | 'remove' }>();
  @Output() onOwnlistAction = new EventEmitter<{ movie: any, action: 'add' | 'remove' }>();

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.updateAllListStates();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.movies && changes.movies.currentValue) {
      this.updateAllListStates();
    }
  }

  /** Updates list states for all movies - call this when movies array changes */
  updateAllListStates(): void {
    if (!this.movies) {
      return;
    }
    for (let i = 0; i < this.movies.length; i++) {
      const movie = this.movies[i];
      if (movie) {
        movie._inWishlist = ListHelper.isItemInWishlist(movie);
        movie._inOwnlist = ListHelper.isItemInOwnlist(movie);
        movie._inBlocklist = ListHelper.isItemInBlocklist(movie, Global.getStore());
      }
    }
  }

  /** Updates list state for a single movie after action */
  updateMovieListState(movie: any): void {
    if (movie) {
      movie._inWishlist = ListHelper.isItemInWishlist(movie);
      movie._inOwnlist = ListHelper.isItemInOwnlist(movie);
      movie._inBlocklist = ListHelper.isItemInBlocklist(movie, Global.getStore());
    }
  }

  isLoggedIn(): boolean {
    return StorageHelper.getInstance().get(StorageHelper.keys.sessionToken) != null;
  }

  toggleWishlist(e: Event, movie: any): void {
    e.preventDefault();
    e.stopPropagation();
    if (!this.isLoggedIn()) {
      LoginHelper.getInstance().requestLogin();
      return;
    }
    const action = movie._inWishlist ? 'remove' : 'add';
    movie._inWishlist = !movie._inWishlist; // Optimistic UI update
    this.onWishlistAction.emit({ movie: movie, action: action });
  }

  toggleOwnlist(e: Event, movie: any): void {
    e.preventDefault();
    e.stopPropagation();
    if (!this.isLoggedIn()) {
      LoginHelper.getInstance().requestLogin();
      return;
    }
    const action = movie._inOwnlist ? 'remove' : 'add';
    movie._inOwnlist = !movie._inOwnlist; // Optimistic UI update
    this.onOwnlistAction.emit({ movie: movie, action: action });
  }

  getDetailViewUrl(movie): string {
    if (!movie) {
      return "";
    }

    const id = movie.idInStore || movie.itemID;
    if (!id) {
      return "";
    }

    const country = Global.getCountry();
    const storeUrl = Global.getStoreUrl();
    const mediaType = Global.getMediaTypeForDetailView();
    const title = movie.title;

    if (!country || !storeUrl || !mediaType || !title) {
      return "";
    }

    return '/' + country + '/' + storeUrl + '/' + mediaType + '/' + id + '/' + StringHelper.slugify(title);
  }

  getImageUrl(movie): string {

    if (!movie) {
      return "";
    }

    if (Config.useIvan && movie.idInStore) {
      return Config.imageServerUrl + Global.getCountry() + "/" + movie.idInStore + "/400x400.jpg";
    }
    else {

      //The urls for the small, medium and large images are comma-separated in one field
      //We generally want the largest one, so this function only returns the largest,
      //Which is the last one
      const urls: string = movie.imageLargeUrl || movie.itemImageURL;
      if (urls){
        const urlArray = urls.split(",");
        if(urlArray) {
          const url = urlArray[urlArray.length - 1];
          return StringHelper.getImageHttpsUrl(url);
        }
        return "";
      }
      else {
        return "";
      }

    }

  }

  /** @deprecated Use movie._inWishlist property instead for template bindings */
  isInWishlist(movie: any): boolean {
    return movie ? movie._inWishlist : false;
  }

  /** @deprecated Use movie._inOwnlist property instead for template bindings */
  isInOwnlist(movie: any): boolean {
    return movie ? movie._inOwnlist : false;
  }

  /** @deprecated Use movie._inBlocklist property instead for template bindings */
  isInBlocklist(movie: any): boolean {
    return movie ? movie._inBlocklist : false;
  }

}
